import { t } from '@lingui/core/macro'
import { Text, View } from '@react-pdf/renderer'
import React from 'react'

import type { PdfStyles } from './PdfPrimitives'

export function PdfFooter({
  label,
  styles,
}: {
  label: string
  styles: PdfStyles
}): React.ReactElement {
  return (
    <View style={styles.footer} fixed>
      <Text
        render={({ pageNumber, totalPages }) =>
          t`${label} · Page ${pageNumber} of ${totalPages}`
        }
      />
    </View>
  )
}
